module.exports = __webpack_public_path__ + "img/user.59377537.svg";